import styled from 'styled-components';

export default styled.h4`
  float: left;
  align-self: center;
  font-weight: 400 !important;
  font-size: 16px !important;
   
`;
